import React from 'react';
import PropTypes from 'prop-types';
import {
  StyledCounter,
} from './StyledCounter';

const Counter = ({
  value,
  variant = 'default',
  ...rest
}) => {

  return (
    <StyledCounter
      variant={variant}
      {...rest}
    >
      {value}
    </StyledCounter>
  );
}

Counter.propTypes = {
  variant: PropTypes.oneOf(['default', 'error', 'success'])
}

export default Counter;
